import { Tooltip } from "@xola/ui-kit";
import React, { ReactNode, useEffect, useRef, useState } from "react";

/**
 * Automatically shows up tooltip content incase the children scroll width
 * is more than client width (basically truncated)
 *
 * Note: we need to have truncate class on children that we pass itself
 * TODO: To be moved into ui-kit tooltip cont
 */

interface AutoTooltipContainerProps {
    children: React.ReactNode;
    tooltipContent: ReactNode | string;
}

interface AutoTooltipContainerProps {
    children: React.ReactNode;
    tooltipContent: React.ReactNode | string;
}

export const AutoTooltipContainer = ({ children, tooltipContent }: AutoTooltipContainerProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            const container = ref.current;
            if (container) {
                const isOverflowing = container.scrollWidth > container.clientWidth;
                setShowTooltip(isOverflowing);
            }
        };

        checkOverflow();
        window.addEventListener("resize", checkOverflow);

        return () => window.removeEventListener("resize", checkOverflow);
    }, []);

    return (
        <Tooltip content={tooltipContent} disabled={!showTooltip}>
            <div ref={ref} className="max-w-full overflow-hidden text-ellipsis whitespace-nowrap">
                {children}
            </div>
        </Tooltip>
    );
};
